import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnlockAlt } from '@fortawesome/free-solid-svg-icons';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, t, ...rest }) => {
    const columns = [
        {
            header: t('Role_Name'),
            accessor: 'displayName',
            sortable: false
        },
        {
            header: t('Role_Description'),
            accessor: 'description',
            sortable: true
        },
        {
            header: t('Role_Enabled'),
            accessor: 'enabled',
            sortable: true,
            cell: (enabled) => (ui.formatBoolean(enabled))
        },
        {
            header: t('Common_Actions'),
            accessor: 'id',
            cell: (id, role) => role.isSystem ? <Link to={`/permissions/${('role')}/${id}/${role.name}`} className='btn btn-teal'><FontAwesomeIcon icon={faUnlockAlt} /> {t('Common_Permissions')}</Link> :
                (<div>
                    <Link to={`/permissions/${('role')}/${id}/${role.name}`} className='btn btn-teal'><FontAwesomeIcon icon={faUnlockAlt} /> {t('Common_Permissions')}</Link>&nbsp;
                    <Link to={`/roles/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={isReadonly ? faEye : faEdit} /> {t(isReadonly ? 'Common_View' : 'Common_Edit')}</Link>
                </div>)
        }
    ];

    return (
        <Panel>
            <Panel.Body>
                <PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath='/roles/new' />} {...rest} />
            </Panel.Body>
        </Panel>
    );
};

export default withTranslation()(List);